import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-da5f3700"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "checkStyle" };
const _hoisted_2 = /*#__PURE__*/ _createTextVNode("和");
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" 知道了 ");
import { ref } from "vue";
import CloudDialog from "@/components/CloudDialog/index.vue";
import CloudButton from "@/components/CloudButton/index.vue";
import { useAgreement } from "./hooks/agreement";
export default /*#__PURE__*/ _defineComponent({
    name: 'Agreement',
    props: {
        title: { default: "" }
    },
    setup(__props) {
        const { agreeContent } = useAgreement();
        const currentContent = ref("serve");
        const agreeShow = ref(false);
        const agreeHandle = (type) => {
            currentContent.value = type;
            agreeShow.value = true;
        };
        const closeHandle = () => {
            agreeShow.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("span", _hoisted_1, [
                    _createTextVNode(_toDisplayString(__props.title) + "即代表同意 ", 1),
                    _createElementVNode("span", {
                        class: "aStyle cursor",
                        onClick: _cache[0] || (_cache[0] = ($event) => (agreeHandle('serve')))
                    }, "《服务条款》"),
                    _hoisted_2,
                    _createElementVNode("span", {
                        class: "aStyle cursor",
                        onClick: _cache[1] || (_cache[1] = ($event) => (agreeHandle('privacy')))
                    }, "《隐私政策》")
                ]),
                _createVNode(CloudDialog, {
                    id: "agreeDialog",
                    modelValue: agreeShow.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((agreeShow).value = $event)),
                    "show-footer": false,
                    title: _unref(agreeContent)[currentContent.value].title,
                    width: "60%",
                    onDialogClose: closeHandle
                }, {
                    footer: _withCtx(() => [
                        _createVNode(CloudButton, {
                            type: "deep",
                            size: "large",
                            onClick: closeHandle
                        }, {
                            default: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            (_unref(agreeContent)[currentContent.value])
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(agreeContent)[currentContent.value]), { key: 0 }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ], 64));
        };
    }
});
